/* WildBoard: linkify the PDP minimum-board line to the board builder. Loaded site-wide by wb-header; only acts where a .moq element exists (the three PDPs). Progressive enhancement, degrades to plain text. */
(function(){
  var PHRASE='mix any 3 across flavors';
  var HREF='/pages/build-a-board';
  function run(){
    var moqs=document.querySelectorAll('.moq');
    for(var i=0;i<moqs.length;i++){
      var el=moqs[i];
      if(el.getAttribute('data-wb-linked')) continue;
      var h=el.innerHTML;
      if(h.indexOf(PHRASE)>-1 && h.indexOf(HREF)<0){
        el.innerHTML=h.replace(PHRASE,'<a href="'+HREF+'" style="color:inherit;text-decoration:underline;text-underline-offset:2px">'+PHRASE+'</a>');
        el.setAttribute('data-wb-linked','1');
      }
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();
